$(function () {
    $('select[name=prefecture_id]').on('change', function () {
        $.ajax(
            '/ajax/cities/' + $(this).val(),
            {method: 'get'}
        ).done(function (json) {
            let selectBox = $('select[name=city_id]');
            selectBox.empty();
            $('<option>').val('').text('----').appendTo(selectBox);
            $.each(json, function (id, name) {
                let option = $('<option>').val(id).text(name);
                option.appendTo(selectBox);
            });
            selectBox.val((typeof selectBox.data('default') == 'undefined') ? '' : selectBox.data('default'));
        });
    }).change();
});
